// src/features/game/saveSlots.js
export function loadSlots() {
  try { return JSON.parse(localStorage.getItem('saves')) || [null, null, null]; }
  catch { return [null, null, null]; }
}
export function saveSlot(i, hero, progress) {
  const arr = loadSlots();
  arr[i] = { hero, progress, ts: Date.now() };
  localStorage.setItem('saves', JSON.stringify(arr));
}
export function deleteSlot(i) {
  const arr = loadSlots();
  arr[i] = null;
  localStorage.setItem('saves', JSON.stringify(arr));
}
